import { isVAGManufacturer, useAvailableVehicleSearchOptions } from "@tm/utils"
import { CircularProgress, Icon, IconButton, Tooltip } from "@tm/components"
import { RegistrationNoType, Vehicle } from "@tm/models"
import { useEffect, useMemo, useState } from "react"
import { useLocalization } from "@tm/localization"
import { useVehicleRecordDataSources } from "@tm/data/vehicleRecords/hooks/useVehicleRecordDataSources"
import { useQueryClient } from "react-query"
import { VehicleRecords } from "@tm/data"

type AutoDAPInfoProps = {
    vehicle: Vehicle
}

export function AutoDAPInfoComponent(props: AutoDAPInfoProps) {
    const { vehicle } = props
    const queryClient = useQueryClient()
    const { translateText } = useLocalization()
    const { availableVehicleSearches } = useAvailableVehicleSearchOptions()
    const { vehicleRecordDataSources, isLoading: vehicleRecordDataSourcesLoading } = useVehicleRecordDataSources(vehicle?.id ?? "")
    const [showLoading, setShowLoading] = useState<boolean>(vehicleRecordDataSourcesLoading)
    const isAutoDAPEnabled = useMemo(() => {
        return availableVehicleSearches.configuredVehicleLookups.some((search) => search.lookupTypeId === RegistrationNoType.VrmVINAutoDAP)
    }, [availableVehicleSearches])

    useEffect(() => {
        if (!vehicleRecordDataSourcesLoading) {
            setShowLoading(vehicleRecordDataSourcesLoading)
        }
    }, [vehicleRecordDataSourcesLoading])

    function fetchVehicleRecords() {
        setShowLoading(true)
        VehicleRecords.fetchVehicleRecords(vehicle.id, queryClient)
    }

    if (!isAutoDAPEnabled || !isVAGManufacturer(vehicle.tecDocManufacturerId)) {
        return null
    }

    if (!vehicle.vin) {
        return (
            <Tooltip title={translateText(14049)}>
                <Icon size="extralarge" name="auto-dap-hint" />
            </Tooltip>
        )
    }

    if (showLoading) {
        return <CircularProgress size={20} />
    }

    if (!vehicleRecordDataSources || !vehicleRecordDataSources?.dataSources.some((val) => val === RegistrationNoType.VrmVINAutoDAP)) {
        return (
            <Tooltip title={translateText(14047)}>
                <IconButton noPadding size="extralarge" onClick={fetchVehicleRecords}>
                    <Icon name="auto-dap-questionmark" />
                </IconButton>
            </Tooltip>
        )
    }
    return (
        <Tooltip title={translateText(14048)}>
            <Icon size="extralarge" name="auto-dap-check" />
        </Tooltip>
    )
}
